import React from 'react';
import { whatsappLink, darkLogo } from '../data/mock';
import { Facebook, Instagram } from 'lucide-react';

const Footer = () => {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="footer">
      <div className="container">
        <div className="footer-content">
          <div className="footer-brand">
            <div className="footer-brand-header">
              <img 
                src={darkLogo} 
                alt="ZenKo" 
                className="logo-footer"
              />
              {/* Social icons for mobile - next to logo */}
              <div className="social-links social-links-mobile">
                <a 
                  href="https://www.facebook.com/profile.php?id=61586119034843" 
                  target="_blank" 
                  rel="noopener noreferrer"
                  className="social-icon"
                  aria-label="Facebook"
                >
                  <Facebook size={20} />
                </a>
                <a 
                  href="https://www.instagram.com/zenkosv/" 
                  target="_blank" 
                  rel="noopener noreferrer"
                  className="social-icon"
                  aria-label="Instagram"
                >
                  <Instagram size={20} />
                </a>
              </div>
            </div>
            <p className="footer-tagline">
              Bienestar simple. Resultados reales.
            </p>
            {/* Social icons for desktop - below tagline */}
            <div className="social-links social-links-desktop">
              <a 
                href="https://www.facebook.com/profile.php?id=61586119034843" 
                target="_blank" 
                rel="noopener noreferrer"
                className="social-icon"
                aria-label="Facebook"
              >
                <Facebook size={24} />
              </a>
              <a 
                href="https://www.instagram.com/zenkosv/" 
                target="_blank" 
                rel="noopener noreferrer"
                className="social-icon"
                aria-label="Instagram"
              >
                <Instagram size={24} />
              </a>
            </div>
          </div>

          <div className="footer-links">
            <div className="footer-column">
              <h4 className="heading-3 !font-['Trebuchet_MS']">Navegación</h4>
              <ul className="footer-list">
                <li><a href="#" onClick={(e) => { e.preventDefault(); window.scrollTo({ top: 0, behavior: 'smooth' }); }} className="footer-link">Inicio</a></li>
                <li><a href="#objetivos" className="footer-link">Objetivos</a></li>
                <li><a href="#productos" className="footer-link">Suplementos destacados</a></li>
                <li><a href="#faq" className="footer-link">Preguntas frecuentes</a></li>
              </ul>
            </div>

            <div className="footer-column">
              <h4 className="heading-3 !font-['Trebuchet_MS']">Contacto</h4>
              <ul className="footer-list">
                <li>WhatsApp: +503 6976-8437</li>
                <li>Envíos a todo El Salvador</li>
                <li><a href={whatsappLink} target="_blank" rel="noopener noreferrer" className="footer-link">Escríbenos</a></li>
                <li><a href="https://vitrinnea.com.sv/shop/www.zenkosv.com" target="_blank" rel="noopener noreferrer" className="footer-link">Búscanos en Vitrinnea como ZenKo</a></li>
              </ul>
            </div>
          </div>
        </div>

        <div className="footer-bottom">
          <p className="body-small">
            © {currentYear} ZenKo. Todos los derechos reservados.
          </p>
          <p className="body-small text-secondary">
            La información proporcionada es solo para fines educativos y no sustituye el consejo médico profesional.
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;